import { Box } from '@chakra-ui/react'
import React from 'react'
import { BsFillArrowLeftCircleFill } from 'react-icons/bs'
import { useNavigate } from 'react-router-dom'

const GoBack = () => {
    const navigate = useNavigate()
    const handleBack = () => {
        navigate(-1)
    }
    return (
        <Box>
            <BsFillArrowLeftCircleFill style={{ fontSize: '24px', cursor: 'pointer' }} onClick={handleBack} />
        </Box>
    )
}

export default GoBack